<ng-container *transloco="let t; read: 'profile'">
  <div class="componentContainer">
    <section class="xs12col componentHeader">
      <h1>{{t('profilOf')}} {{(profile$.getValue().firstName)}} {{profile$.getValue().lastName}}</h1>
    </section>

    <section class="twoCol">
      <div class="xs12col m6col">
          <div class="boxContainer">
            <div class="box">
              <h2>{{t('personalInformation')}}</h2>
  
              <div class="">
                <form class="" [formGroup]="profileForm">
  
                  <kendo-formfield>
                      <kendo-label [for]="userName" [text]="t('userName')"></kendo-label>
                      <kendo-textbox
                          formControlName="userName"
                          #userName
                          [readonly]="true"
                      ></kendo-textbox>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="company" [text]="t('company')"></kendo-label>
                    <kendo-textbox
                        formControlName="company"
                        #company
                        [readonly]="true"
                    ></kendo-textbox>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="role" [text]="t('role')"></kendo-label>
                    <kendo-textbox
                      formControlName="role"
                      #role
                      [readonly]="true"
                    ></kendo-textbox>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="firstName" [text]="t('firstName')"></kendo-label>
                    <kendo-textbox
                      formControlName="firstName"
                      #firstName
                      [readonly]="true"
                    ></kendo-textbox>
                    <kendo-formerror>{{t('errorFirstName')}}</kendo-formerror>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="lastName" [text]="t('lastName')"></kendo-label>
                    <kendo-textbox
                      formControlName="lastName"
                      #lastName
                      [readonly]="true"
                    ></kendo-textbox>
                    <kendo-formerror>{{t('errorLastName')}}</kendo-formerror>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="email" [text]="t('email')"></kendo-label>
                    <kendo-textbox
                      formControlName="email"
                      #email
                      [readonly]="true"
                    ></kendo-textbox>
                  </kendo-formfield>
  
                  <kendo-formfield>
                    <kendo-label [for]="phoneNumber" [text]="t('phoneNumber')"></kendo-label>
                    <kendo-maskedtextbox
                      #phoneNumber
                      formControlName="phoneNumber"
                      [mask]="phoneNumberMask"
                      [value]="phoneNumberValue"
                      [readonly]="true"
                    ></kendo-maskedtextbox>
                  </kendo-formfield>
                </form>
              </div>
            </div>
          </div>
      </div>
      
      <div class="xs12col m6col">
        <div class="boxContainer">
          <div class="box">
            <h2>{{t('passwordChange')}}</h2>
            <div class="">
              <form class="" [formGroup]="passwordForm">

                <kendo-formfield>
                    <kendo-label [for]="password" [text]="t('password')"></kendo-label>
                    <input
                      kendoTextBox
                      type="password"
                      class="mbs"
                      formControlName="password"
                      #password
                      required
                    >
                </kendo-formfield>

                <kendo-formfield>
                  <kendo-label [for]="newPassword" [text]="t('newPassword')"></kendo-label>
                  <input
                    kendoTextBox
                    type="password"
                    class="mbs"
                    formControlName="newPassword"
                    #newPassword
                    required
                  >
                </kendo-formfield>

                <kendo-formfield>
                  <kendo-label [for]="confirmNewPassword" [text]="t('confirmNewPassword')"></kendo-label>
                  <input
                    kendoTextBox
                    type="password"
                    class="mbs"
                    formControlName="confirmNewPassword"
                    #confirmNewPassword
                    required
                  >
                </kendo-formfield>
                <button
                  kendoButton
                  class="buttonPrimary"
                  type="submit"
                  (click)="submitPasswordChange()"
                  [disabled]="passwordForm.invalid"
                >{{t('passwordChange')}}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  </section>
  </div>
</ng-container>
